export class NextStepConfirmationDto {
  message: string;
  title: string;
  typeConfirmation: NextStepConfirmationEnum

  constructor(typeConfirmation?: NextStepConfirmationEnum, title?: string, message?: string) {
    this.typeConfirmation = typeConfirmation;
    this.title = title;
    this.message = message;
  }
}

export enum NextStepConfirmationEnum {
  LISTE_BESOINS_FERMETURES_PONCTUELLES = 'LISTE_BESOINS_FERMETURES_PONCTUELLES'
}
